<template>
    <div class="summary-template-dropdown">
        <span v-if="templates.length === 0" class="n-color-text-weak text-sm">
            No summary templates available for your profession. Please update your profile.
        </span>
        <nord-dropdown v-else :size="size" :disabled="disabled" align="end" ref="dropdown">
            <nord-button
                slot="toggle"
                :size="size"
                :disabled="disabled || loading"
                :loading="loading"
            >
                {{ buttonLabel }}
                <nord-icon slot="end" name="arrow-down-small"></nord-icon>
            </nord-button>

            <nord-dropdown-item
                v-for="template in templates"
                :key="template.key"
                @click="selectTemplate(template)"
                :active="selectedTemplate && selectedTemplate.key === template.key"
            >
                <div class="template-item">
                    <div class="template-name">{{ template.label }}</div>
                    <div v-if="template.sections && template.sections.length > 0" class="template-sections">
                        {{ template.sections.join(', ') }}
                    </div>
                </div>
            </nord-dropdown-item>
        </nord-dropdown>
    </div>
</template>

<script>
export default {
    name: 'SummaryTemplateDropdown',

    props: {
        templates: {
            type: Array,
            required: true,
            default: () => []
        },
        value: {
            type: Object,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'm',
            validator: (value) => ['s', 'm', 'l'].includes(value)
        }
    },

    computed: {
        selectedTemplate() {
            return this.value;
        },

        buttonLabel() {
            return this.selectedTemplate ? this.selectedTemplate.label : 'Select template';
        }
    },

    methods: {
        selectTemplate(template) {
            this.$emit('input', template);
            this.$emit('change', template);

            // Close the dropdown after selection
            this.$nextTick(() => {
                if (this.$refs.dropdown) {
                    this.$refs.dropdown.hide(true);
                }
            });
        }
    }
};
</script>

<style scoped>
.summary-template-dropdown {
    display: inline-block;
}

.summary-template-dropdown nord-dropdown {
    --n-index-popout: 9999;
}

.template-item {
    display: flex;
    flex-direction: column;
    gap: var(--n-space-xs);
}

.template-name {
    font-weight: var(--n-font-weight-medium);
}

.template-sections {
    font-size: var(--n-font-size-xs);
    line-height: var(--n-line-height-xs);
    color: var(--n-color-text-weak);
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

/* Ensure sections text is light on hover */
nord-dropdown-item:hover .template-sections {
    color: var(--n-color-text-weak-inverted);
}
</style>
